import { AfterContentInit, Component, ContentChildren, EventEmitter, Input, OnInit, Output, QueryList, TemplateRef } from '@angular/core';
import { FilterService, IFilterSubject } from '../../services/filter.service';
import { debounceTime, filter } from 'rxjs';
import { IFilterModel } from '../../models/filter-model';

@Component({
  selector: 'split-group-filter',
  templateUrl: './split-group-filter.component.html',
  styleUrls: ['./split-group-filter.component.scss']
})
export class SplitGroupFilterComponent implements OnInit, AfterContentInit {

  @Input() id!: string;
  @Input() showClearButton = true;
  @Output() onFilterEvent: EventEmitter<IFilterModel[]> = new EventEmitter();

  get filterActive() {
    return this.filterService
               .filters
               .filter(filter => filter.id === this.id && (filter.component == undefined || filter.component.required == false))
               .some(filter => filter.filter.length > 0);
  }

  constructor(private filterService: FilterService) {}

  ngOnInit(): void {
    this.filterService.filterSubject.pipe(
      filter((event: IFilterSubject) => event.id === this.id),
      debounceTime(500)
    ).subscribe(
      (filter: IFilterSubject) => {
        console.log(this.filterService.filters)
        this.onFilterEvent.emit(filter.array.filter((item) => item.id === this.id));
      }
    );
  }

  ngAfterContentInit() {
    //console.log(this.components); // 1, BUT it's a reference to itself, not the child
    /*this.components.forEach((component) => {
      component.onFilterEvent.subscribe((filter: IFilterModel[]) => {
       console.log(filter);
      });
    })*/
  }


  clear() {
    this.filterService.clear(this.id);
  }

}
